import { FullHeightVideosProps } from '@/components/portfolio/components/fullHeightVideos'
import { HorizontalImagesShowcaseProps } from '@/components/portfolio/components/horizontalImagesShowcase'
import { ImagesGridProps } from '@/components/portfolio/components/imagesGrid'
import { ImageTopDescriptionBottomProps } from '@/components/portfolio/components/imageTopDescriptionBottom'
import { PresentationSlideProps } from '@/components/portfolio/components/presentationSlide/index'
import { SingleImageProps } from '@/components/portfolio/components/singleImage'

type clientSEO = {
  title: string
  description: string
}

export type CFImage = {
  url: string
  width: number
  height: number
}

export type CFVideo = {
  id: string
  cover?: string
}

export enum PortfolioComponent {
  presentationSlide,
  horizontalImagesShowcase,
  imageGrid,
  imageTopDescriptionBottom,
  fullHeightVideos,
  singleImage
}

type block =
  | {
      id: number
      componentName: PortfolioComponent.presentationSlide
      props: PresentationSlideProps
    }
  | {
      id: number
      componentName: PortfolioComponent.horizontalImagesShowcase
      props: HorizontalImagesShowcaseProps
    }
  | {
      id: number
      componentName: PortfolioComponent.imageGrid
      props: ImagesGridProps
    }
  | {
      id: number
      componentName: PortfolioComponent.imageTopDescriptionBottom
      props: ImageTopDescriptionBottomProps
    }
  | {
      id: number
      componentName: PortfolioComponent.fullHeightVideos
      props: FullHeightVideosProps
    }
  | {
      id: number
      componentName: PortfolioComponent.singleImage
      props: SingleImageProps
    }

export type clientPageData = {
  seo: clientSEO
  blocks: block[]
}

export type clientHomeData = {
  slug: string
  name: string
  types: string[]
  image: CFImage
}
